<template>
  <div class="wrapper">
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item label="订单状态">
          <el-select v-model="value" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.goodsNumber"
            clearable
          />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.userPhone"
            clearable
          />
        </el-form-item>
        <el-form-item label="详细收货地址">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.userAddress"
            clearable
          />
        </el-form-item>
        <el-form-item label="收货人名字">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.userName"
            clearable
          />
        </el-form-item>
        <el-form-item label="发货时间">
          <el-date-picker
            v-model="deliverDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="完成时间">
          <el-date-picker
            v-model="finishDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker
            v-model="paymentDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="value2" clearable placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-button
            size="mini"
            type="primary"
            style="margin-left: 20px"
            @click="getList"
            >查询</el-button
          >
          <el-button
            size="mini"
            type="primary"
            style="margin-left: 20px"
            @click="clearList"
            >清空查询条件</el-button
          >
        </el-row>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="goodsNumber"
          label="订单号"
          align="center"
          width="210"
          fixed
        >
          <template slot-scope="{ row }">
            <span
              @click="copy"
              class="btns"
              :data-clipboard-text="row.goodsNumber"
              style="cursor: pointer"
            >
              {{ row.goodsNumber }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderStatus"
          label="状态"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <span v-if="row.orderStatus == 0">待付款</span>
            <span v-if="row.orderStatus == 1">待发货</span>
            <span v-if="row.orderStatus == 2">待收货</span>
            <div v-if="row.orderStatus == 3">
              <span>用户申请退款中</span>
              <el-button
                size="mini"
                round
                type="warning"
                style="margin-top: 10px"
                @click="refund(row)"
                >同意退款</el-button
              >
              <!-- 确定将总价xxx退还吗 -->
            </div>
            <span v-if="row.orderStatus == 4">退款完成</span>
            <span v-if="row.orderStatus == 5">待评价</span>
            <span v-if="row.orderStatus == 6">交易完成</span>
            <span v-if="row.orderStatus == -1">已取消</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="payType"
          label="支付方式"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <span v-if="row.payType == 1">支付宝</span>
            <span v-if="row.payType == 2">微信</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="refund"
          label="子订单是否退款"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <span v-if="row.refund == 1">有</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="userName"
          label="用户昵称"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="userPhone"
          label="联系电话"
          align="center"
          width="120"
        ></el-table-column>

        <el-table-column
          prop="totalPrice"
          label="订单总价"
          align="center"
          width="90"
        ></el-table-column>
        <el-table-column
          prop="userAddress"
          label="收货地址"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="paymentDate"
          label="支付时间"
          align="center"
          width="150"
        ></el-table-column>

        <el-table-column
          prop="finishDate"
          label="完成时间"
          align="center"
          width="150"
        ></el-table-column>

        <el-table-column
          prop="deliverDate"
          label="发货时间"
          align="center"
          width="150"
        ></el-table-column>

        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          width="120"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 5px"
                type="primary"
                @click="detailSpu(row)"
                >详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: auto; marginright: 50px; margintop: 20px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>
    <!-- 同意退款 -->
    <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>
        确定将总价<b class="price">{{ price }}</b
        >退还吗？
      </p>
    </a-modal>
    <!-- 详情页面 -->
    <a-drawer
      title="详情"
      :width="1400"
      :visible="detailVisibile"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Detail :Detaildata="detailData" />
    </a-drawer>
  </div>
</template>
<script>
import Detail from "./detail";
import Clipboard from "clipboard";
export default {
  components: {
    Detail,
  },
  data() {
    return {
      list: [],
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      detailVisibile: false,
      delOpen: false,
      detailData: [],
      deliverDate: "", //发货时间
      paymentDate: "", //支付时间
      finishDate: "", //完成时间
      searchData: {
        goodsNumber: "",
        deliverDateStart: "", //发货时间-起始
        deliverDateEnd: "", //发货时间-结束
        finishDateStart: "", //完成时间-开始
        finishDateEnd: "", //发货时间-结束
        paymentDateStart: "", //支付时间-起始
        paymentDateEnd: "", //支付时间-结束
        userPhone: "", //手机号
        userAddress: "", //详细收货地址
        userName: "", //收货人名字
      },
      options: [
        {
          value: "0",
          label: "待付款",
        },
        {
          value: "1",
          label: "待发货",
        },
        {
          value: "2",
          label: "待收货",
        },
        {
          value: "3",
          label: "用户申请退款中",
        },
        {
          value: "4",
          label: "退款完成",
        },
        {
          value: "5",
          label: "待评价",
        },
        {
          value: "6",
          label: "交易完成",
        },
        {
          value: "-1",
          label: "已取消",
        },
      ],
      options2: [
        {
          value: "1",
          label: "支付宝",
        },
        {
          value: "2",
          label: "微信",
        },
      ],
      value: "",
      value2: "",
      price: "",
      orderId: "",
    };
  },
  methods: {
    // 详情
    detailSpu(row) {
      this.detailVisibile = true;
      this.detailData = row;
    },
    //获取
    init() {
      this.postAxios("/order/list", {
         pageEntity: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        order: {
          orderStatus: this.value,
          goodsNumber: this.searchData.goodsNumber, //订单号
          userPhone: this.searchData.userPhone, //手机号
          userAddress: this.searchData.userAddress, //详细收货地址
          userName: this.searchData.userName, //收货人名字
          deliverDateStart: this.deliverDate[0], //发货时间-起始
          deliverDateEnd: this.deliverDate[1], //发货时间-結束
          finishDateStart: this.finishDate[0], //完成时间-开始
          finishDateEnd: this.finishDate[1], //完成时间-結束
          paymentDateStart: this.paymentDate[0], //支付时间-开始
          paymentDateEnd: this.paymentDate[1], //支付时间-結束
          payType: this.value2,
        },
      }).then((res) => {
        if (res.success) {
          this.list = res.content;
          this.totalCount = res.totalCount;
        } else {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    getList() {
      this.currentPage = 1;
      this.postAxios("/order/list", {
        pageEntity: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        order: {
          orderStatus: this.value,
          goodsNumber: this.searchData.goodsNumber, //订单号
          userPhone: this.searchData.userPhone, //手机号
          userAddress: this.searchData.userAddress, //详细收货地址
          userName: this.searchData.userName, //收货人名字
          deliverDateStart: this.deliverDate[0], //发货时间-起始
          deliverDateEnd: this.deliverDate[1], //发货时间-結束
          finishDateStart: this.finishDate[0], //完成时间-开始
          finishDateEnd: this.finishDate[1], //完成时间-結束
          paymentDateStart: this.paymentDate[0], //支付时间-开始
          paymentDateEnd: this.paymentDate[1], //支付时间-結束
          payType: this.value2,
        },
      }).then((res) => {
        if (res.success) {
          this.list = res.content;
          this.totalCount = res.totalCount;
        } else {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    refund(row) {
      this.delOpen = true;
      this.price = row.totalPrice;
      this.orderId = row.id;
    },
    clearList() {
      this.searchData = {};
      this.value = "";
      this.value2 = "";
      this.paymentDate = "";
      this.deliverDate = "";
      this.finishDate = "";
      this.currentPage = 1;
      this.getList();
    },
    onClose() {
      this.detailVisibile = false;
      this.getList();
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    handleOk() {
      this.getAxios("/order/main/refund", {
        orderId: this.orderId,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
          this.delOpen = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.init();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.init();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped lang="less">
.wrapper {
  width: 95%;
  height: auto;
  margin: 20px auto;
}
.price {
  font-size: 22px;
  color: rgb(245, 108, 108);
  margin: 0 10px;
}
p {
  margin: 0;
}
/deep/ .ant-modal {
  top: 350px !important;
}
</style>